import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useEffect, useState } from "react";
import { getUnitCharges, updateUnitCharges } from "api/api";
import DataTable from "examples/Tables/DataTable";
import { CheckPermissionRender } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import MDButton from "../../components/MDButton";
import { Icon, IconButton } from "@mui/material";
import { UnitChargeType } from "../../constants/unit_charge_types";
import AddChargeForm from "./add_charge_form";
import chargesData from "./data/charges_data";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";

function Configurations() {
  const [state, setState] = useState({
    addType: null,
    fixedCharges: [],
    perUnitCharges: [],
  });

  const isMobile = useIsMobile();

  const fetchUnitCharges = async () => {
    const response = await getUnitCharges();
    if (response) {
      setState({
        addType: null,
        fixedCharges: response.fixed_charges,
        perUnitCharges: response.per_unit_charges,
      });
    }
  };

  const onDelete = (type) => {
    const charges =
      type == UnitChargeType.FIXED ? [...state.fixedCharges] : [...state.perUnitCharges];
    charges.pop();
    if (type == UnitChargeType.FIXED) {
      setState({
        ...state,
        fixedCharges: charges,
      });
    } else {
      setState({
        ...state,
        perUnitCharges: charges,
      });
    }
  };

  const onAddCharge = (type) => {
    setState({ ...state, addType: type });
  };

  const onSave = async () => {
    global.showConfDialog(
      "Are you sure?",
      <span>This action will update your organization's configurations</span>,
      async () => {
        await updateUnitCharges({
          unit_charges: [
            ...state.perUnitCharges.map((puc) => ({
              units_from: puc.units_from,
              price: puc.price,
              type: UnitChargeType.PER_UNIT,
            })),
            ...state.fixedCharges.map((fcu) => ({
              units_from: fcu.units_from,
              price: fcu.price,
              type: UnitChargeType.FIXED,
            })),
          ],
        });
      },
      ["Confirm", "Cancel"]
    );
  };

  useEffect(() => {
    fetchUnitCharges();
  }, []);

  const { columns: perUniChargeColumns, rows: peUnitChargeRows } = chargesData(
    state.perUnitCharges,
    onDelete,
    UnitChargeType.PER_UNIT
  );
  const { columns: fixedChargeColumns, rows: fixedChargeRows } = chargesData(
    state.fixedCharges,
    onDelete,
    UnitChargeType.FIXED
  );

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={1}
              >
                <MDTypography variant="h6" color="white">
                  Configurations
                </MDTypography>
                <CheckPermissionRender permissions={permissions().orgConfig().update().list()}>
                  <MDButton
                    variant="gradient"
                    color="dark"
                    onClick={onSave}
                    style={{ width: "fit-content" }}
                  >
                    Save changes
                  </MDButton>
                </CheckPermissionRender>
              </MDBox>
              <MDBox pt={3}>
                <MDBox display="flex" gap={3} alignItems="center" p={3}>
                  <MDTypography>Per unit charges</MDTypography>
                  <CheckPermissionRender permissions={permissions().orgConfig().update().list()}>
                    <IconButton onClick={() => onAddCharge(UnitChargeType.PER_UNIT)}>
                      <Icon>add</Icon>
                    </IconButton>
                  </CheckPermissionRender>
                </MDBox>
                <DataTable
                  table={{ columns: perUniChargeColumns, rows: peUnitChargeRows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <MDBox display="flex" gap={3} alignItems="center" p={3}>
                  <MDTypography>Fixed charges</MDTypography>
                  <CheckPermissionRender permissions={permissions().orgConfig().update().list()}>
                    <IconButton onClick={() => onAddCharge(UnitChargeType.FIXED)}>
                      <Icon>add</Icon>
                    </IconButton>
                  </CheckPermissionRender>
                </MDBox>
                <DataTable
                  table={{ columns: fixedChargeColumns, rows: fixedChargeRows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <CheckPermissionRender permissions={permissions().orgConfig().update().list()}>
        <AddChargeForm state={state} setState={setState} />
      </CheckPermissionRender>
    </DashboardLayout>
  );
}

export default Configurations;
